import React, { useContext } from 'react';
import { doEncryptLocal } from '@express-labs/raven-tools';
import MyAccountIcon from './MyAccountIcon';
import LoggedInIcon from '../LoggedInIcon';
import { HeaderDynamicContext } from '../../../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import { LOCAL_STORAGE_SECRET } from '../../../../../../constants';
import getFromStorage from '../../../../../../helpers/storage/storage';

function AccountIcon(props) {
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  const userDataFromContext = useContext(HeaderDynamicContext);

  if (Object.entries(loyaltyWarmStateData).length > 0) {
    const encryptedFirstName = localStorage.getItem('firstName');
    const firstName = encryptedFirstName
      && doEncryptLocal.doDecrypt(LOCAL_STORAGE_SECRET, encryptedFirstName);

    const userData = {
      firstName,
      lastName: loyaltyWarmStateData.lastName,
      rewardsTotal: userDataFromContext?.loyaltyRewards?.rewardsTotal,
    };

    return <LoggedInIcon userData={userData} {...props} />;
  }

  if (userDataFromContext && userDataFromContext.customer
    && userDataFromContext.customer.loginStatus === true) {
    userDataFromContext.customer.rewardsTotal = userDataFromContext?.loyaltyRewards?.rewardsTotal;
    return <LoggedInIcon {...props} userData={userDataFromContext.customer} />;
  }
  return <MyAccountIcon {...props} />;
}

export default AccountIcon;
